var _path, _polygon, _polygon2, _path2, _polygon3, _polygon4, _path3, _polygon5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _polygon6, _polygon7, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HEXAGON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1202.32,2585.45h-481L480.83,2168.9l240.49-416.56h481l240.49,416.56-.86,1.5Zm-477.53-6h474.06l237-410.55-237-410.56H724.79l-237,410.56Z",
    fill: "#8ac9ef"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "485.3 2999 6.04 2999 6.04 2993 481.83 2993 718.87 2582.45 481.83 2171.9 6.04 2171.9 6.04 2165.9 485.3 2165.9 725.79 2582.45 485.3 2999",
    fill: "#8ac9ef"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1436.75 2997.5 1198.85 2585.45 724.79 2585.45 486.89 2997.5 481.69 2994.5 721.32 2579.45 1202.32 2579.45 1441.95 2994.5 1436.75 2997.5",
    fill: "#8ac9ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1918.81,2999h-481l-240.49-416.55.86-1.5,239.63-415h481l240.49,416.55-.86,1.5Zm-477.53-6h474.06l237-410.55-237-410.55H1441.28l-237,410.55Z",
    fill: "#8ac9ef"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "2877.4 3001.5 2637.58 2585.45 2159.68 2585.45 1919.87 3001.5 1914.67 2998.5 2156.22 2579.45 2641.05 2579.45 2882.6 2998.5 2877.4 3001.5",
    fill: "#8ac9ef"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "2641.04 2585.45 2156.23 2585.45 1913.8 2168.9 1914.68 2167.39 2155.36 1753.84 2160.54 1756.85 1920.74 2168.9 2159.68 2579.45 2637.59 2579.45 2877.41 2167.39 2882.59 2170.41 2641.04 2585.45",
    fill: "#8ac9ef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M724.79,2585.45h-481L3.3,2168.9l240.49-416.56h481L965.28,2168.9l-.86,1.5Zm-477.53-6H721.32l237-410.55-237-410.56H247.26l-237,410.56Z",
    fill: "#8ac9ef"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.3 2171.89 6.04 2171.89 6.04 2165.89 481.83 2165.89 718.87 1755.34 481.83 1344.79 6.04 1344.79 6.04 1338.79 485.3 1338.79 725.79 1755.34 485.3 2171.89",
    fill: "#8ac9ef"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 739.29,
    cy: 1007.29,
    r: 27.64,
    fill: "#8ac9ef"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.33,
    cy: 1755.34,
    r: 27.64,
    fill: "#8ac9ef"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.35,
    cy: 2168.9,
    r: 27.64,
    fill: "#8ac9ef"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1654.71,
    cy: 1403.93,
    r: 27.64,
    fill: "#8ac9ef"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2155.84,
    cy: 1737.38,
    r: 27.64,
    fill: "#8ac9ef"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2891.48,
    cy: 2150.44,
    r: 27.64,
    fill: "#8ac9ef"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "1657.71 1758.34 1200.59 1758.34 1200.59 1752.34 1651.71 1752.34 1651.71 1431.57 1657.71 1431.57 1657.71 1758.34",
    fill: "#8ac9ef"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "486.56 1341.79 480.56 1341.79 480.56 1004.29 722.33 1004.29 722.33 1010.29 486.56 1010.29 486.56 1341.79",
    fill: "#8ac9ef"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2155.84,
    cy: 2582.45,
    r: 51.58,
    fill: "#8ac9ef"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.33,
    cy: 2582.45,
    r: 51.58,
    fill: "#8ac9ef"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 484.29,
    cy: 2168.89,
    r: 51.58,
    fill: "#8ac9ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkBg);
export default __webpack_public_path__ + "static/media/network-bg.d471c226b5c217a1ee442acca1a1b8cd.svg";
export { ForwardRef as ReactComponent };